import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  UpsertPinLimitPayload,
  getUserPinLimits,
  upsertUserPinLimit
} from '../../api/user-pin-limit.api';

const PIN_LIMITS_QUERY_KEY = ['userPinLimits'] as const;

export const useGetPinLimits = () => {
  const query = useQuery({
    queryKey: PIN_LIMITS_QUERY_KEY,
    queryFn: getUserPinLimits
  });

  // Transform array into a Record keyed by currency_code for easy lookup
  const configuredLimits: Record<string, number> = {};
  if (query.data) {
    for (const item of query.data) {
      configuredLimits[item.currency_code] = item.pin_limit;
    }
  }

  return { ...query, configuredLimits };
};

export const useUpsertPinLimit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpsertPinLimitPayload) => upsertUserPinLimit(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PIN_LIMITS_QUERY_KEY });
    }
  });
};
